import React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import { device } from '../device';
import { BackButton } from '../theme/globalStyle';
import { StepperContext } from '../contexts/stepperContext';

const StyledHeader = styled.header`
  min-height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  left: 0;
  padding: 2vw 2vw 0 2vw;
  width: auto;
  position: relative;

  &.withoutProgress {
    padding: 2vw 2vw 0 2vw;
    z-index: 100;
    background-color: transparent;
    position: absolute;
    width: 96vw;
    justify-content: flex-end;
    left: 50%;
    transform: translateX(-50%);
  }

  @media ${device.tablet} {
    padding: 2vw 2vw 0 2vw;
  }
  @media ${device.laptopL} {
    padding: 30px 2vw 0 2vw;
  }
`;

const Header = function ({ currentPage }) {
  const { dispatch } = React.useContext(StepperContext);

  return (
    <StyledHeader className={clsx({ withoutProgress: currentPage < 1 })}>
      {currentPage > 0 && (
        <BackButton
          onClick={() => {
            if (currentPage === 2) {
              dispatch({ type: 'setParts', printerParts: null });
              dispatch({ type: 'setClientValue', clientValue: '' });
              dispatch({ type: 'setCurrentParts', currentPart: 0 });
            }
            dispatch({ type: 'previous' });
          }}
        />
      )}
    </StyledHeader>
  );
};

export default Header;
